/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_RevokeInputs */

const cs_client_portal_revoke = /** @type {(inputs: Client_Portal_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit přístup`)
};

const en_client_portal_revoke = /** @type {(inputs: Client_Portal_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoke access`)
};

/**
* | output |
* | --- |
* | "Revoke access" |
*
* @param {Client_Portal_RevokeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_revoke = /** @type {((inputs?: Client_Portal_RevokeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_RevokeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_revoke(inputs)
	return cs_client_portal_revoke(inputs)
});